/* =========================================================================
   A/B-Test Variante B — Slide-Cart Drawer (Controller)
   -------------------------------------------------------------------------
   window.openCompleteDrawer()  -> oeffnet den vollstaendigen Slide-Cart.
   PERF Phase 3: laedt statisch via layout/theme.liquid (defer) auf jeder
   Seite und ist der Standard-Cart; window.preCardOpenHandler (siehe unten)
   zeigt auf open(). Baut sich beim ersten Oeffnen lazy auf.

   Datenfluss:
     - Inhalt (Items + RABATT + Totals): Section-Rendering /?section_id=ab-slide-cart
     - Upsells: aus /cart die .cart-page__products-w extrahieren (wie die PreCart)
     - Mengen/Remove: /cart/change.js (mit sections-Param -> direkt frisches HTML)
     - Checkout: window.location = /checkout  (ueberspringt die /cart-Seite)
   Bewusst unabhaengig von Dawn (<cart-items>) und CartJS-Bindings; nach eigenen
   Mutationen wird CartJS nur zum Re-Sync der Header-Anzeige angestossen.
   ========================================================================= */
(function () {
  'use strict';

  var SECTION_ID = 'ab-slide-cart';
  var built = false, panelInner, panelUpsells, footHost, checkoutBtn, root;
  var refreshing = false;
  var sheet, sheetState = null, cartModels = [];

  var COLOR_MAP = {
    'gold': '#c9a14a', 'silber': '#c4c4c4', 'silver': '#c4c4c4',
    'schwarz': '#222', 'black': '#222', 'weiss': '#efefef', 'weiß': '#efefef', 'white': '#f2f2f2',
    'roségold': '#e6b8a2', 'rosegold': '#e6b8a2', 'rosé': '#e6b8a2',
    'blau': '#3a5a8c', 'blue': '#3a5a8c', 'grün': '#5a7d5a', 'gruen': '#5a7d5a',
    'beige': '#d8c8a8', 'braun': '#7a5a3a', 'rot': '#a33', 'pink': '#d98aa8'
  };
  function colorDot(v) { var k = (v || '').toLowerCase().trim(); return COLOR_MAP[k] || null; }
  function escAttr(s) { return String(s).replace(/"/g, '&quot;'); }
  function escHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function money(cents) {
    try { return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }

  // Lieferzeitraum (Logik aus snippets/shipping-date-cart.liquid uebernommen)
  function deliveryRange() {
    var days = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
    function calc(kind) {
      var t = new Date(), d = new Date(t);
      if (kind === 'shipping') {
        d.setDate(t.getDate() + 4);
        if (d.getDay() === 0 || d.getDay() <= 3) d.setDate(d.getDate() + 1);
      } else {
        d.setDate(t.getDate() + 2);
        if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      }
      return days[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
    }
    return calc('now') + ' – ' + calc('shipping');
  }

  function cfg() { return window.__AB_PRECART || {}; }

  // ----- Shell einmalig bauen ------------------------------------------------
  function build() {
    if (built) return;
    root = document.createElement('div');
    root.className = 'ab-cart';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', 'Warenkorb');
    root.innerHTML =
      '<div class="ab-cart__overlay" data-ab-close></div>' +
      '<aside class="ab-cart__panel">' +
        '<div class="ab-cart__top">' +
          '<p class="ab-cart__title">Dein Warenkorb</p>' +
          '<button type="button" class="ab-cart__close" data-ab-close aria-label="Schliessen">&times;</button>' +
        '</div>' +
        '<div class="ab-cart__scroll">' +
          '<div class="ab-cart__inner-host" data-ab-host></div>' +
          '<div class="ab-cart__upsells" data-ab-upsells></div>' +
        '</div>' +
        '<div class="ab-cart__foot">' +
          '<div class="ab-cart__foot-host" data-ab-foot-host></div>' +
          '<button type="button" class="ab-cart__checkout" data-ab-checkout>Jetzt sicher zur Kasse</button>' +
          '<button type="button" class="ab-cart__continue" data-ab-close>Weiter einkaufen</button>' +
          '<div class="ab-cart__trust"><span>30 Tage Rückgabe</span><span>Handmade in Germany</span></div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(root);

    panelInner = root.querySelector('[data-ab-host]');
    panelUpsells = root.querySelector('[data-ab-upsells]');
    footHost = root.querySelector('[data-ab-foot-host]');
    checkoutBtn = root.querySelector('[data-ab-checkout]');
    buildSheet(root.querySelector('.ab-cart__panel'));

    // Schliessen
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ab-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    // Checkout -> direkt, /cart-Seite uebersprungen
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.hasAttribute('disabled')) return;
      window.location.href = '/checkout';
    });
    // Mengen / Remove (Event-Delegation auf injiziertem Markup)
    panelInner.addEventListener('click', function (e) {
      var li = e.target.closest('[data-ab-line-key]');
      if (!li) return;
      var key = li.getAttribute('data-ab-line-key');
      var cur = parseInt(li.querySelector('[data-ab-qty-val]').textContent, 10) || 1;
      if (e.target.closest('[data-ab-remove]')) return changeLine(key, 0);
      if (e.target.closest('[data-ab-qty-plus]')) return changeLine(key, cur + 1);
      if (e.target.closest('[data-ab-qty-minus]')) return changeLine(key, Math.max(0, cur - 1));
    });

    // Upsell-Interaktion: Single-Variant addet direkt, Mehr-Varianten -> Bottom-Sheet
    panelUpsells.addEventListener('click', function (e) {
      var sheetBtn = e.target.closest('[data-ab-up-sheet]');
      if (sheetBtn) {
        var card = sheetBtn.closest('.ab-up__card');
        var dataEl = card && card.querySelector('[data-ab-up-data]');
        if (dataEl) { try { openSheet(JSON.parse(dataEl.textContent)); } catch (e2) {} }
        return;
      }
      var add = e.target.closest('[data-ab-up-add]');
      if (add) addUpsell(add.getAttribute('data-variant-id'), add);
    });

    // Falls Cart anderweitig (ausserhalb Drawer) geaendert wird -> auffrischen
    try {
      if (window.jQuery) {
        window.jQuery(document).on('cart.requestComplete', function () {
          if (root.classList.contains('is-open') && !refreshing) refreshInner();
        });
      }
    } catch (e) {}

    built = true;
  }

  // ----- Inhalt laden / auffrischen -----------------------------------------
  function loading(on) { if (root) root.classList.toggle('is-loading', !!on); }

  function injectInner(html) {
    // html = voller Section-Render; .ab-cart__inner + .ab-cart__foot-data herausloesen
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.ab-cart__inner');
      var foot = doc.querySelector('.ab-cart__foot-data');
      var meta = doc.querySelector('[data-ab-cart-meta]');
      if (inner) panelInner.innerHTML = inner.outerHTML;
      if (foot && footHost) {
        footHost.innerHTML = foot.outerHTML;
        // Lieferdatum clientseitig fuellen
        var del = footHost.querySelector('[data-ab-delivery]');
        if (del) del.textContent = deliveryRange();
      }
      var count = 0;
      if (meta) { try { count = (JSON.parse(meta.textContent) || {}).item_count || 0; } catch (e) {} }
      setCheckoutEnabled(count > 0);
    } catch (e) { /* fail safe: nichts */ }
  }

  function fetchSection() {
    return fetch('/?section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); });
  }

  function refreshInner() {
    refreshing = true;
    return fetchSection()
      .then(injectInner)
      .catch(function () {})
      .then(function () { refreshing = false; });
  }

  // Drawer-native Upsells laden (eigene Section -> filtert ausverkaufte,
  // Heading nur bei verfuegbaren, Varianten-Picker fuer Mehr-Varianten-Produkte)
  function loadUpsells() {
    return fetch('/?section_id=ab-slide-cart-upsells', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var up = doc.querySelector('.ab-up');
        panelUpsells.innerHTML = up ? up.outerHTML : '';
        var injected = panelUpsells.querySelector('.ab-up');
        if (injected && injected.dataset.cartModels) {
          try { cartModels = JSON.parse(injected.dataset.cartModels) || []; } catch (e) { cartModels = []; }
        }
      })
      .catch(function () { panelUpsells.innerHTML = ''; });
  }

  // ===== Bottom-Sheet: Per-Option-Varianten-Auswahl ==========================
  function buildSheet(parent) {
    if (!parent || sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'ab-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="ab-sheet__backdrop" data-ab-sheet-close></div>' +
      '<div class="ab-sheet__panel">' +
        '<button type="button" class="ab-sheet__close" data-ab-sheet-close aria-label="Schliessen">&times;</button>' +
        '<div class="ab-sheet__head">' +
          '<img class="ab-sheet__img" alt="" data-ab-sheet-img>' +
          '<div class="ab-sheet__head-txt">' +
            '<div class="ab-sheet__title" data-ab-sheet-title></div>' +
            '<div class="ab-sheet__price" data-ab-sheet-price></div>' +
          '</div>' +
        '</div>' +
        '<div class="ab-sheet__options" data-ab-sheet-options></div>' +
        '<button type="button" class="ab-sheet__add" data-ab-sheet-add disabled>In den Warenkorb</button>' +
      '</div>';
    parent.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ab-sheet-close]')) return closeSheet();
      var add = e.target.closest('[data-ab-sheet-add]');
      if (add && !add.disabled && sheetState && sheetState.variantId) {
        addUpsell(sheetState.variantId, add);
        closeSheet();
        return;
      }
      var pill = e.target.closest('[data-ab-opt]');
      if (pill && !pill.disabled && sheetState) {
        sheetState.sel[parseInt(pill.getAttribute('data-opt'), 10)] = pill.getAttribute('data-val');
        renderSheetOptions();
        updateSheet();
      }
    });
  }

  function resolveVariant(sel) {
    var vs = sheetState.data.variants;
    for (var i = 0; i < vs.length; i++) {
      var o = vs[i].o, match = true;
      for (var j = 0; j < sel.length; j++) { if (o[j] !== sel[j]) { match = false; break; } }
      if (match) return vs[i];
    }
    return null;
  }

  function hasAvailable(oi, val) {
    var vs = sheetState.data.variants;
    for (var i = 0; i < vs.length; i++) { if (vs[i].a && vs[i].o[oi] === val) return true; }
    return false;
  }

  function openSheet(data) {
    if (!sheet || !data || !data.variants) return;
    sheetState = { data: data, sel: [], variantId: null };
    var firstAvail = null;
    for (var i = 0; i < data.variants.length; i++) { if (data.variants[i].a) { firstAvail = data.variants[i]; break; } }
    var base = firstAvail ? firstAvail.o.slice() : (data.variants[0] ? data.variants[0].o.slice() : []);
    sheetState.sel = base.slice();
    // Smart-Default: Werte aus dem Warenkorb (z.B. Handymodell) vorwaehlen,
    // sofern die Kombination verfuegbar bleibt.
    for (var oi = 0; oi < data.options.length; oi++) {
      var vals = data.options[oi].values;
      for (var k = 0; k < vals.length; k++) {
        if (cartModels.indexOf(vals[k]) > -1) {
          var trial = sheetState.sel.slice(); trial[oi] = vals[k];
          var rv = resolveVariant(trial);
          if (rv && rv.a) sheetState.sel = trial;
          break;
        }
      }
    }
    sheet.querySelector('[data-ab-sheet-img]').src = data.img || '';
    sheet.querySelector('[data-ab-sheet-title]').textContent = data.title || '';
    renderSheetOptions();
    updateSheet();
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
  }

  function renderSheetOptions() {
    var data = sheetState.data, host = sheet.querySelector('[data-ab-sheet-options]'), html = '';
    for (var oi = 0; oi < data.options.length; oi++) {
      var opt = data.options[oi], isColor = /farbe|colou?r/i.test(opt.name);
      html += '<div class="ab-sheet__opt"><div class="ab-sheet__opt-label">' + escHtml(opt.name) + '</div><div class="ab-sheet__opt-vals">';
      for (var vi = 0; vi < opt.values.length; vi++) {
        var val = opt.values[vi], dead = !hasAvailable(oi, val), seld = sheetState.sel[oi] === val;
        html += '<button type="button" class="ab-sheet__pill' + (seld ? ' is-sel' : '') + (isColor ? ' is-color' : '') + '" data-ab-opt data-opt="' + oi + '" data-val="' + escAttr(val) + '"' + (dead ? ' disabled' : '') + '>';
        if (isColor) { var d = colorDot(val); if (d) html += '<span class="ab-sheet__dot" style="background:' + d + '"></span>'; }
        html += escHtml(val) + '</button>';
      }
      html += '</div></div>';
    }
    host.innerHTML = html;
  }

  function updateSheet() {
    var v = resolveVariant(sheetState.sel);
    var priceEl = sheet.querySelector('[data-ab-sheet-price]'), addBtn = sheet.querySelector('[data-ab-sheet-add]');
    if (v && v.a) {
      sheetState.variantId = v.id;
      priceEl.textContent = money(v.p);
      addBtn.disabled = false;
      addBtn.textContent = 'In den Warenkorb · ' + money(v.p);
    } else {
      sheetState.variantId = null;
      priceEl.textContent = v ? money(v.p) : '';
      addBtn.disabled = true;
      addBtn.textContent = 'Nicht verfügbar';
    }
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    setTimeout(function () { sheet.hidden = true; }, 260);
  }

  // Upsell zum Warenkorb -> /cart/add.js (variantenspezifisch), dann Drawer auffrischen
  function addUpsell(variantId, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    loading(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return Promise.all([refreshInner(), loadUpsells()]); })
      .then(function () { syncHeaderCount(null); })
      .catch(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } })
      .then(function () { loading(false); });
  }

  // ----- Mengen-/Remove-Mutation --------------------------------------------
  function changeLine(key, qty) {
    loading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTION_ID, sections_url: '/' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections[SECTION_ID]) injectInner(data.sections[SECTION_ID]);
        else refreshInner();
        syncHeaderCount(data && typeof data.item_count === 'number' ? data.item_count : null);
        loadUpsells(); // Upsell-Vorschlaege haengen vom Cart-Inhalt ab
      })
      .catch(function () { refreshInner(); })
      .then(function () { loading(false); });
  }

  // Header-Cart-Count via CartJS re-syncen (wir mutieren ausserhalb von CartJS)
  function syncHeaderCount(count) {
    try { if (window.CartJS && typeof window.CartJS.getCart === 'function') { window.CartJS.getCart(); return; } } catch (e) {}
    if (count == null) return;
    try {
      document.querySelectorAll('.cart-count,[data-cart-count]').forEach(function (el) { el.textContent = count; });
    } catch (e) {}
  }

  function setCheckoutEnabled(on) {
    if (!checkoutBtn) return;
    if (on) checkoutBtn.removeAttribute('disabled');
    else checkoutBtn.setAttribute('disabled', 'disabled');
  }

  // ----- Open / Close --------------------------------------------------------
  function open() {
    build();
    document.body.classList.add('ab-cart-open');
    root.classList.add('is-open');
    loading(true);
    Promise.all([refreshInner(), loadUpsells()]).then(function () { loading(false); });
  }
  function close() {
    if (!root) return;
    closeSheet();
    root.classList.remove('is-open');
    document.body.classList.remove('ab-cart-open');
  }

  // Oeffentliche API
  window.openCompleteDrawer = open;
  window.closeCompleteDrawer = close;

  // PERF Phase 3 (A/B-Rueckbau): Der Slide-Cart ist Standard. Alle
  // Add-to-Cart-Pfade des Themes rufen window.preCardOpenHandler
  // (product-form.js, configurator-logic.js:1878, bag-configurator-
  // scripts.js:839, swatch_variants_handler.js, precard-screen-protection)
  // — frueher zeigte der auf das PreCart-Popup (precard.js, entfernt) und
  // wurde von ab-precart.js (entfernt) auf den Drawer umgebogen. Jetzt
  // zeigt er direkt auf den Drawer.
  window.preCardOpenHandler = open;

  // ----- Header-Cart-Icon in Bucket B -> Drawer statt /cart-Seite ------------
  document.addEventListener('click', function (e) {
    var c = cfg();
    if (c.bucket !== 'B' || !c.variantActive) return;
    var link = e.target.closest('a.header__cart, a[href$="/cart"], a[href="/cart"]');
    if (!link) return;
    e.preventDefault();
    open();
  }, true);

  // ----- Produktkarten-Add (Collection/Search/Popup) ------------------------
  // Diese nativen [data-product-form2]-Formulare haben KEIN Theme-JS und wuerden
  // per Browser-POST hart auf /cart-Seite redirecten. Da diese Datei NUR in
  // Bucket B laedt, faengt der Handler hier ausschliesslich B ab -> AJAX-Add +
  // Drawer. (A bleibt unberuehrt: Datei nicht geladen -> nativer POST -> /cart.)
  document.addEventListener('submit', function (e) {
    var c = cfg();
    if (c.bucket !== 'B' || !c.variantActive) return;
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-product-form2]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id'), qty = parseInt(fd.get('quantity'), 10) || 1;
    if (!id) { try { HTMLFormElement.prototype.submit.call(form); } catch (e2) {} return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { syncHeaderCount(null); open(); })
      .catch(function () { try { HTMLFormElement.prototype.submit.call(form); } catch (e3) {} });
  }, true);
})();
